module.exports = __webpack_public_path__ + "static/media/out-of-coins-static-image.c631ec0d.png";